import { app } from '../../../../app';
import { Controller } from './sms-purchase.controller';

app.component('smsPurchase', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./sms-purchase.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/sms-purchase/sms-purchase.component.js